<template>
  <Modal title="Выбор иконки достижения" @backdrop-click="close">
    <template slot="body">
      <div class="content__list_icons vert-scroll">
        <div
          v-for="iconName in iconsList"
          :key="iconName"
          class="icons__icon"
          @click="selectIcon(iconName)"
        >
          <Unicon
            :name="iconName"
            fill="#fff"
            height="80"
            width="80"
          />
        </div>
      </div>
    </template>
    <template slot="footer">
      <div>
        <button
          type="button"
          class="btn btn-danger"
          @click="close"
        >
          Выйти
        </button>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/_shared/components/ui/Modal';
export default {
  emits: ['select', 'close'],
  components: {
    Modal,
  },
  mounted() {
    document.querySelector('body').style.overflow = 'hidden';
  },
  computed: {
    iconsList() {
      const list = [
        'award', 'trophy', 'medal', 'award-alt',
        'thumbs-up', 'thumbs-down', 'coins', 'star',
        'grin', 'smile', 'check',
      ];
      return list;
    },
  },
  methods: {
    selectIcon(name) {
      this.$emit('select', name);
      this.close();
    },
    close() {
      document.querySelector('body').style.overflow = 'auto';
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.content__list_icons {
  display: grid;
  grid-template-columns: repeat(4, auto);
  column-gap: 1.2em;
  row-gap: 1.2em;
  max-height: 200px;
  overflow-y: auto;
  padding-right: 1.2em;
}
.icons__icon {
  background: #0088cc;
  border-radius: 10px;
  margin: 0 auto;
}
.icons__icon:hover {
  cursor: pointer;
  opacity: 0.5;
  transition: 0.3s;
}
@media (max-width: 767px) {
  .content__list_icons {
    grid-template-columns: repeat(3, auto);
  }
}
@media (max-width: 419px) {
  .content__list_icons {
    grid-template-columns: repeat(2, auto);
  }
}
</style>



// WEBPACK FOOTER //
// src/user/features/achievements/IconSelectorModal.vue